<template>
	<span>
		<span class="badge badge-primary tag" v-for="(tag, i) in valueArray">
			{{categories[tag] ? categories[tag].name : $t('status.error')}}
		</span>
	</span>
</template>

<script>
var cache = require('./category-cache');
module.exports = {
	name: 'c-categories',
	cache: cache.data,
	props: ['value'],
	data: () => ({
		cache: cache.data
	}),
	computed: {
		categories () {
			return this.cache.categories;
		},
		valueArray () {
			return (this.value + '').split(',');
		}
	},
	created () {
		cache.prepare(this);
	}
};
</script>



// WEBPACK FOOTER //
// c-categories.vue?7280e7c1